import { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import './Header.css'
import { useTranslation } from 'react-i18next'
import useIsMobile from '../../hooks/useIsMobile'
import { LanguageSelect } from './LanguageSelect/LanguageSelect'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const isMobile = useIsMobile()

  const { t } = useTranslation()

  const scrollToSolutions = () => {
    const el = document.getElementById('solutions')
    if (!el) return

    const yOffset = -100
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset

    window.scrollTo({ top: y, behavior: 'smooth' })
  }

  const scrollToMaturity = () => {
    const el = document.getElementById('maturidade')
    if (!el) return

    const yOffset = 0
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset

    window.scrollTo({ top: y, behavior: 'smooth' })
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const navItems = [
    { label: t('header.home'), to: '/' },
    { label: t('header.solutions'), match: '/' },
    { label: t('header.maturity'), match: '/' },
    { label: t('header.apllos'), to: '/apllos' },
    { label: t('header.cases'), to: '/cases' },
    { label: t('header.recognition'), to: '/recognition' },
    { label: t('header.contact'), to: '/contact' },
  ]

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const handleNavClick = (item, e) => {
    if (item.label === t('header.solutions')) {
      e.preventDefault()
      if (location.pathname !== '/') {
        navigate('/')
      }

      setTimeout(() => {
        scrollToSolutions()
      }, 100)
      closeMenu()
      return
    }

    if (item.label === t('header.maturity')) {
      e.preventDefault()
      if (location.pathname !== '/') {
        navigate('/')
      }

      setTimeout(() => {
        scrollToMaturity()
      }, 100)
      closeMenu()
      return
    }

    if (item.to === location.pathname) {
      e.preventDefault()
      scrollToTop()
      closeMenu()
      return
    }

    closeMenu()
  }

  const isSelected = (item) => {
    if (item.to) return location.pathname === item.to
    if (item.onClick) return location.pathname === (item.match ?? '/')
    return false
  }

  useEffect(() => {
    closeMenu()
  }, [location.pathname])

  useEffect(() => {
    if (!isMenuOpen) return

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeMenu()
      }
    }

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKeyDown)

    return () => {
      document.body.style.overflow = previousOverflow
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [isMenuOpen])

  return (
    <div className="Header">
      <img
        src="/assets/Header/sem bordas branco.png"
        alt="Logo Apllos"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          closeMenu()
          if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          } else {
            navigate('/')
          }
        }}
      />

      <button
        type="button"
        className="header-menu-toggle"
        aria-label="Abrir menu"
        aria-expanded={isMenuOpen}
        onClick={() => setIsMenuOpen((prev) => !prev)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`header-nav ${isMenuOpen ? 'is-open' : ''}`}>
        <ul className="nav-list">
          {navItems.map((item) => (
            <li key={item.label} className={isSelected(item) ? 'selected' : ''}>
              <Link
                to={item.to}
                state={item.state}
                onClick={(e) => handleNavClick(item, e)}
              >
                {item.label}
              </Link>
            </li>
          ))}
          {isMobile && (
            <li className="lang-item">
              <LanguageSelect />
            </li>
          )}
        </ul>
      </nav>

      {!isMobile && <LanguageSelect />}

      {isMenuOpen && (
        <div className="header-overlay" onClick={closeMenu} aria-hidden="true" />
      )}
    </div>
  )
}

export default Header
